module.exports = "<p>Esta es una pagina protegida por GUARD!</p>\n"